import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdminContextState {
  selectedFacilityId: string;
  setSelectedFacilityId: (id: string) => void;
}

/**
 * Persisted store for the admin's currently selected facility context.
 * Survives page navigation and browser refresh.
 */
export const useAdminContextStore = create<AdminContextState>()(
  persist(
    (set) => ({
      selectedFacilityId: '',
      setSelectedFacilityId: (id: string) => set({ selectedFacilityId: id }),
    }),
    { name: 'csam-admin-context' }
  )
);
